package net.bothosting.docs.pages.troubleshooting

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*

@InitRoute
fun initCannot_find_module_modulenotfounderror_no_such_file_or_directoryPage(ctx: InitRouteContext) {
    ctx.data.add(MarkdownContext("troubleshooting/cannot_find_module_modulenotfounderror_no_such_file_or_directory.md", FrontMatterElement.Builder { addScalar("description", "Node.js and Python issues"); }))
}

@Page("/troubleshooting/cannot-find-module-modulenotfounderror-no-such-file-or-directory")
@Layout(".components.layouts.DocsLayout")
@Composable
fun Cannot_find_module_modulenotfounderror_no_such_file_or_directoryPage() {
    org.jetbrains.compose.web.dom.H1(attrs = { id("cannot-find-module-modulenotfounderror-no-such-file-or-directory") }) {
        org.jetbrains.compose.web.dom.Text("Cannot find module / ModuleNotFoundError / No such file or directory")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Node.js: ")
        org.jetbrains.compose.web.dom.Code {
            org.jetbrains.compose.web.dom.Text("Cannot find module 'MODULENAME OR FILE DIRECTORY'")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Python: ")
        org.jetbrains.compose.web.dom.Code {
            org.jetbrains.compose.web.dom.Text("ModuleNotFoundError: No module named 'MODULENAME'")
        }
        org.jetbrains.compose.web.dom.Text(" or ")
        org.jetbrains.compose.web.dom.Code {
            org.jetbrains.compose.web.dom.Text("/usr/local/bin/python: can't open file '/home/container/bot.py': [Errno 2] No such file or directory")
        }
    }
    org.jetbrains.compose.web.dom.Ol {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Your code or startup settings are looking for a file in a specific directory, but it cannot be found. Please make sure that the file exists, has no spaces before or after the name, and is in the correct directory.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("A package required by your code cannot be found on the server. This usually indicates that you did not upload the ")
            org.jetbrains.compose.web.dom.Code {
                org.jetbrains.compose.web.dom.Text("package.json")
            }
            org.jetbrains.compose.web.dom.Text(" file or did not fill in the startup field for it. Please follow ")
            com.varabyte.kobweb.silk.components.navigation.Link("../hosting_in_bot_hosting_net/set_up_a_server.md#id-0sliscetlmx") {
                org.jetbrains.compose.web.dom.Text("this explanation")
            }
            org.jetbrains.compose.web.dom.Text(" for a fix.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("An error occurred before this one. Please check your console, and if you cannot identify that error, open a support ticket.")
        }
    }
}
